export default {
    backendHost: function () {
        let host = window.location.hostname.toLowerCase();
        let result = 'http://localhost:1337';
        let staging = 'https://www.recruitment.staging.hopesg.org.sg/api';
        let production = 'https://recruitment.hopesg.org.sg/api';
        result = staging;

        // staging demo
        if (host.includes('www.recruitment.staging.hopesg.org.sg')) {
            result = staging;
        }

        if (host.includes('recruitment.hopesg.org.sg')) {
            result = production;
        }

        return result;
    },

    authApiHost: function () {
        let host = window.location.hostname.toLowerCase();
        let result = 'http://localhost:1338';
        let staging = 'https://auth.staging.hopesg.org.sg/api';
        let production = 'https://auth.hopesg.org.sg/api';
        result = staging;

        // staging demo
        if (host.includes('www.recruitment.staging.hopesg.org.sg')) {
            result = staging;
        }

        if (host.includes('recruitment.hopesg.org.sg')) {
            result = production;
        }

        return result;
    },

    authUiHost: function () {
        let host = window.location.hostname.toLowerCase();
        let result = 'http://localhost:8080';
        let staging = 'https://auth.staging.hopesg.org.sg';
        let production = 'https://auth.hopesg.org.sg';
        result = staging;

        // staging demo
        if (host.includes('www.recruitment.staging.hopesg.org.sg')) {
            result = staging;
        }

        if (host.includes('recruitment.hopesg.org.sg')) {
            result = production;
        }

        return result;
    },

    statusOptions: [
        "Pending Leader Approval",
        "Contact Pastoral Leader",
        "Leader Approved",
        "Rejected by Leader",
        "Applicant Declined",
        "Pending Interview / Audition",
        "Interview / Audition Scheduled",
        "Rejected by Ministry",
        "Accepted by Ministry",
        "Pastoral Rejection Message Sent",
        "Ministry Rejection Message Sent"
    ],

    centreOptions: [
        "Axis Centre",
        "West Centre",
        "NorthEast Centre"
    ],

    congregationOptions: [
        "Ablaze", "Adult", "DialectFellowship", "Filipino", "LYTE", "Mandarin", "University", "Chinese Ministry", "NEC Adult", "WEC Adult"
    ]
}
